module.exports = __webpack_public_path__ + "media/packs/images/flags/LB-39b6413ae539194782a8362661a1114f.svg";